<template>
    <div class="text" ref="handle">
        {{txt}}
    </div>
</template>

<script>
    import { reactive, toRefs, computed, ref } from 'vue'

    //文字渐显特效 + 大字坠落
    export default {
        name: 'TextTransition2',
        props: {
            interval: { type: Number, default: () => 0 },
            txt: { type: String, default: () => '' }
        },
        setup: (props, context) => {
            const handle = ref()
            const state = reactive({
                props,
            })

            return {
                handle,
                ...toRefs(state),
            }
        },
        watch: {
            txt (newValue) {
                console.log('插槽内容变化了：', this.props.interval)
                // this.handle.style.color = '#fff'
                //
                // setTimeout(() => {
                //     this.handle.style.color = 'black'
                // }, this.props.interval + 1000)
            }
        },
        mounted () {
            this.timeId = setTimeout(() => {
                // document.getElementsByTagName('body')[0].style.setProperty('--text-transition2-color', 'black');
                //使用时可能已经销毁
                if (this.handle) {
                    this.handle.style.left = '0'
                    this.handle.style.top = '0'
                    this.handle.style.fontSize = '16px'
                    this.handle.style.color = 'black'
                }
            }, this.props.interval)
        },
        unmounted () {
            clearTimeout(this.timeId)
        }
    }
</script>

<style scoped lang="scss">

    /*$text-transition2-color: var(--text-transition2-color);
    .text {
        display: inline;
        color: $text-transition2-color;
        transition: color 1s;
    }*/

    .text {
        position: relative;
        width: 20px;
        height: 20px;
        line-height: 20px;
        display: inline-block;
        color: #fff0;

        left: -80px;
        top: -80px;
        font-size: 80px;
        transition: color 1s linear,font-size 0.8s linear,left 0.4s linear,top 0.4s linear;

        /*font-size: 16px;*/
        /*animation-name: anima-text-1;*/
        /*animation-duration: 1s;*/
    }
</style>